// import fetch from 'isomorphic-fetch';

// // export const API_URL = `http://localhost:${process.env.PORT || Config.port}/api`;
//  //export const API_URL = `http://localhost:8080`;
// // export const API_URL = `https://partner-api.venuemonk.com`;
// export const API_URL = `https://partner-api.venuemonk.com`;
// export const API_URL_MANAGER =`https://sales-apidev.weddingpe.com`;
// // mobile, desktop --> api
// export default function callApi(endpoint, method = 'get', body) {
//   let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
//   let headers = {};
//   headers['content-type'] = 'application/json';
//   if (token && token !=='') {
//       headers.Authorization = `Bearer ${token}`;
//   }
//   return fetch(`${API_URL}/${endpoint}`, {
//     headers: headers,
//     method,
//     body: JSON.stringify(body),
//   }).then(response => response.json().then(json => ({ json, response })))
//   .then(({ json, response }) => {
//     if (!response.ok) {
//       return Promise.reject(json);
//     }
//     return json;
//   })
//   .then(
//     response => response,
//     error => error
//   );
// }



// export function callApiCallingStatus(endpoint, method = 'get', body) {
//   let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
//   let headers = {};
//   headers['content-type'] = 'application/json';
//   if (token && token !=='') {
//       headers.Authorization = `Bearer ${token}`;
//   }
//   return fetch(`${API_URL_MANAGER}/api/${endpoint}`, {
//       headers: headers,
//       method,
//       body: JSON.stringify(body),
//   })
//       .then(response => response.json().then(json => ({json, response})))
//       .then(({json, response}) => {
//           if (!response.ok) {
//               return Promise.reject(json);
//           }
//           return json;
//       })
//       .then(
//           response => response,
//           error => error
//       );
// }




import fetch from 'isomorphic-fetch';

// export const API_URL = `http://localhost:${process.env.PORT || Config.port}/api`;
 //export const API_URL = `http://localhost:8080`;
// export const API_URL = `https://partner-api.venuemonk.com`;
export const API_URL = `https://manager-api.vmnk.in`;
export const API_URL_MANAGER =`https://sales-apidev.vmnk.in`;
// mobile, desktop --> api
export default function callApi(endpoint, method = 'get', body) {
  let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI1OGI2YWNkMWYzNmQyODFmYWNiNzU2ODgiLCJuYW1lIjoiUml0d2lrIFNhaG9vIiwiaXNfMmZhX3JlcXVpcmVkIjpmYWxzZSwiaXNfMmZhX2VuYWJsZWQiOmZhbHNlLCJhY2Nlc3NfbGV2ZWwiOjAsImlzQWRtaW4iOnRydWUsImhvc3QiOiJhZG1pbiIsInNvdXJjZSI6ImFnZW50LWxvZ2luIiwiaWF0IjoxNzQ0ODA2NTQxfQ.xcKYm4OAyrUe-YAhw6qrJchauFbmnZqQSDjaaU6JKZQ"
  // let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
  let headers = {};
  headers['content-type'] = 'application/json';
  if (token && token !=='') {
      headers.Authorization = `Bearer ${token}`;
  }
  return fetch(`${API_URL}/api/${endpoint}`, {
    headers: headers,
    method,
    body: JSON.stringify(body),
  }).then(response => response.json().then(json => ({ json, response })))
  .then(({ json, response }) => {
    if (!response.ok) {
      return Promise.reject(json);
    }
    return json;
  })
  .then(
    response => response,
    error => error
  );
}



export function callApiCallingStatus(endpoint, method = 'get', body) {
  let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
  let headers = {};
  headers['content-type'] = 'application/json';
  if (token && token !=='') {
      headers.Authorization = `Bearer ${token}`;
  }
  return fetch(`${API_URL_MANAGER}/api/${endpoint}`, {
      headers: headers,
      method,
      body: JSON.stringify(body),
  })
      .then(response => response.json().then(json => ({json, response})))
      .then(({json, response}) => {
          if (!response.ok) {
              return Promise.reject(json);
          }
          return json;
      })
      .then(
          response => response,
          error => error
      );
}